<script>
  export let dark = false;
</script>

<svg class="arrow-down" style="animation-delay: {dark ? '1s' : '0'}" xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 11.25 6.594">
  <defs>
    <style>
        .cls-1 {
            fill: none;
            stroke: #fff;
            stroke-width: 1.5px;
            fill-rule: evenodd;
        }
    </style>
  </defs>
  <path class="cls-1" d="M968.433,683.039l6.376,7.081,6.375-7.081" transform="translate(-969.188 -682.781)"/>
</svg>

<style lang="scss">
  @import "./assets/styles/animations";

  .arrow-down {
    animation: yoyo 3s ease-in-out infinite;
    padding: 1rem;
    width: 1rem;
  }
</style>
